/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiComponentConfig} from "./UiComponentConfig";
import {UiTemplateConfig} from "./UiTemplateConfig";
import {UiLocationConfig} from "./UiLocationConfig";
import {UiMapPolylineConfig} from "./UiMapPolylineConfig";
import {UiMapMarkerConfig} from "./UiMapMarkerConfig";
import {UiMapMarkerClusterConfig} from "./UiMapMarkerClusterConfig";
import {UiHeatMapDataConfig} from "./UiHeatMapDataConfig";
import {UiMapType} from "./UiMapType";


export interface UiMapConfig extends UiComponentConfig {
	_type?: string;
	markerTemplates: {[name: string]: UiTemplateConfig};
	markerIdPropertyName: string;
	mapType?: UiMapType;
	zoomLevel?: number;
	mapPosition?: UiLocationConfig;
	polylines?: {[name: string]: UiMapPolylineConfig};
	markers?: UiMapMarkerConfig[]
}

export interface UiMapCommandHandler {
	addMarker(marker: UiMapMarkerConfig): void;
	addPolyline(lineId: string, polyline: UiMapPolylineConfig): void;
	addPolylinePoints(lineId: string, points: UiLocationConfig[]): void;
	removePolyline(lineId: string): void;
	setZoomLevel(zoom: number): void;
	setLocation(location: UiLocationConfig): void;
	setMapType(mapType: UiMapType): void;
	setMapMarkerCluster(cluster: UiMapMarkerClusterConfig): void;
	setHeatMap(data: UiHeatMapDataConfig): void;
}

export interface UiMapEventSource {
	onZoomLevelChange: TeamAppsEvent<UiMap_ZoomLevelChangeEvent>;
}

export interface UiMap_ZoomLevelChangeEvent extends UiEvent {
	_type: "UiMap.zoomLevelChange";
	redundancyKey?: string;
	zoomLevel: number
}

